var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub",attrs:{"id":"E0-0"}},[_c('div',{staticClass:"wrapper"},[_c('kg-header',{attrs:{"headerType":1}}),_vm._v(" "),_c('kg-category-panel',{on:{"selectCategoryEvent":function($event){_vm.selectCategory($event)}}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35f43b00","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/kagull/pages/FpCategory.vue
// module id = null
// module chunks = 